// import React, { useEffect, useRef } from "react";
// import * as d3 from "d3";

// const BarChart = ({ rawData }) => {
//     const svgRef = useRef();

//     useEffect(() => {
//         if (!rawData?.data) return;

//         // Parse the JSON string to an object
//         const parsedData = JSON.parse(rawData.data);

//         // Convert to an array of objects
//         const data = Object.entries(parsedData).map(([year, value]) => ({
//             year: +year, // Convert year to number
//             value: parseFloat(value.toFixed(2)), // Ensure 2 decimal places
//         }));

//         // Set dimensions and margins 
//         const width = 270;
//         // const width = 240;
//         const height = 200;
//         const margin = { top: 20, right: 20, bottom: 40, left: 40 };

//         // Select the SVG container
//         const svg = d3.select(svgRef.current)
//             .attr("width", width)
//             .attr("height", height)
//             // .style("max-width", "250px")
//             .style("max-width", "300px")
//             .style("min-width", "270px")
//             .style("height", "200");

//         // Remove previous elements before re-rendering
//         svg.selectAll("*").remove();

//         // Scales
//         const x = d3.scaleBand()
//             .domain(data.map(d => d.year))
//             .range([margin.left, width - margin.right])
//             .padding(0.2);

//         const maxValue = d3.max(data, d => d.value) || 1; // Ensure a valid maxValue

//         const y = d3.scaleLinear()
//             .domain([0, maxValue])
//             .range([height - margin.bottom, margin.top])
//             .nice(); // Ensure proper tick spacing

//         // Generate unique tick values dynamically
//         const tickValues = maxValue > 1 ? [...new Set(y.ticks(5))] : [0, maxValue];

//         // Create the y-axis with tick format
//         const yAxis = d3.axisLeft(y)
//             .tickValues(tickValues) // Use filtered unique tick values
//             .tickFormat(d => {
//                 if (rawData.dataType === "percentage") {
//                     return d.toFixed(1) + "%";
//                 } else if (rawData.dataType === "float") {
//                     return d.toFixed(1);
//                 } else if (rawData.dataType === "integer") {
//                     return Math.round(d);
//                 } else {
//                     return d;
//                 }
//             });

//         // Append a group for the y-axis
//         svg.append("g")
//             .attr("transform", `translate(${margin.left},0)`)
//             .call(yAxis);

//         // Draw x-axis
//         svg.append("g")
//             .attr("transform", `translate(0,${height - margin.bottom})`)
//             .call(d3.axisBottom(x));

//         // Draw horizontal grid lines for each tick value
//         tickValues.forEach(tick => {
//             svg.append("line")
//                 .attr("x1", margin.left)
//                 .attr("x2", width - margin.right)
//                 .attr("y1", y(tick))
//                 .attr("y2", y(tick))
//                 .attr("stroke", "#ccc")
//                 .attr("stroke-width", 0.5);
//         });

//         // Only draw bars if values are greater than 0
//         if (maxValue > 0) {
//             svg.selectAll("rect")
//                 .data(data)
//                 .enter().append("rect")
//                 .attr("x", d => x(d.year))
//                 .attr("y", d => y(d.value))
//                 .attr("width", x.bandwidth())
//                 .attr("height", d => height - margin.bottom - y(d.value))
//                 .attr("fill", "#9ECC3B");

//             // Add labels (values) on top of each bar
//             svg.selectAll(".bar-label")
//                 .data(data)
//                 .enter()
//                 .append("text")
//                 .attr("x", d => x(d.year) + x.bandwidth() / 2)
//                 .attr("y", d => y(d.value) - 5)
//                 .attr("text-anchor", "middle")
//                 .text(d => {
//                     if (rawData.dataType === "percentage") {
//                         return d.value.toFixed(0) + "%";
//                     } else if (rawData.dataType === "float") {
//                         return d.value.toFixed(2);
//                     } else if (rawData.dataType === "integer") {
//                         return Math.round(d.value);
//                     } else {
//                         return d.value;
//                     }
//                 })
//                 .attr("font-size", "10px")
//                 .attr("fill", "#1d1d1d");
//         } else {
//             // If all values are zero, show dots along the x-axis
//             svg.selectAll("circle")
//                 .data(data)
//                 .enter()
//                 .append("circle")
//                 .attr("cx", d => x(d.year) + x.bandwidth() / 2)
//                 .attr("cy", y(0))
//                 .attr("r", 3)
//                 .attr("fill", "steelblue");
//         }

//     }, [rawData]);

//     return <svg ref={svgRef}></svg>;
// };



import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const BarChart = ({ rawData }) => {
    const svgRef = useRef();

    useEffect(() => {
        if (!rawData?.data) return;

        // Parse the JSON string to an object
        const parsedData = JSON.parse(rawData.data);

        // Convert to an array of objects
        const data = Object.entries(parsedData).map(([year, value]) => ({
            year: +year, // Convert year to number
            value: parseFloat(value.toFixed(2)), // Ensure proper numeric values
        }));

        // Set dimensions and margins 
        const width = 270;
        const height = 200;
        const margin = { top: 20, right: 20, bottom: 40, left: 40 };

        // Select the SVG container
        const svg = d3.select(svgRef.current)
            .attr("width", width)
            .attr("height", height)
            .style("max-width", "300px")
            .style("min-width", "270px")
            .style("height", "200");

        // Remove previous elements before re-rendering
        svg.selectAll("*").remove();

        // Scales
        const x = d3.scaleBand()
            .domain(data.map(d => d.year))
            .range([margin.left, width - margin.right])
            .padding(0.2);

        const maxValue = d3.max(data, d => d.value) || 1;
        const y = d3.scaleLinear()
            .domain([0, maxValue])
            .range([height - margin.bottom, margin.top])
            .nice();

        // **Dynamic Y-axis Tick Values**
        let tickValues;
        if (maxValue === 1) {
            tickValues = [0, 0.2, 0.4, 0.6, 0.8, 1]; // Special case for 0-1 range
        } else if (maxValue > 1) {
            tickValues = y.ticks(5);
        } else {
            tickValues = [0, maxValue];
        }

        // Create the y-axis with tick format
        const yAxis = d3.axisLeft(y)
            .tickValues(tickValues)
            .tickFormat(d => {
                if (maxValue == 1) {
                    if (rawData.dataType === "percentage") {
                        return d.toFixed(2) + "%";
                    } else {
                        return d;
                    }
                } else if (rawData.dataType === "percentage") {
                    return d.toFixed(2) + "%";
                } else if (rawData.dataType === "float") {
                    return d.toFixed(2);
                } else if (rawData.dataType === "integer") {
                    return Math.round(d);
                } else {
                    return d;
                }
            });

        // Append a group for the y-axis
        svg.append("g")
            .attr("transform", `translate(${margin.left},0)`)
            .call(yAxis);

        // Draw x-axis
        svg.append("g")
            .attr("transform", `translate(0,${height - margin.bottom})`)
            .call(d3.axisBottom(x));

        // Draw horizontal grid lines for each tick value
        tickValues.forEach(tick => {
            svg.append("line")
                .attr("x1", margin.left)
                .attr("x2", width - margin.right)
                .attr("y1", y(tick))
                .attr("y2", y(tick))
                .attr("stroke", "#ccc")
                .attr("stroke-width", 0.5);
        });

        // Only draw bars if values are greater than 0
        if (maxValue > 0) {
            svg.selectAll("rect")
                .data(data)
                .enter().append("rect")
                .attr("x", d => x(d.year))
                .attr("y", d => y(d.value))
                .attr("width", x.bandwidth())
                .attr("height", d => height - margin.bottom - y(d.value))
                .attr("fill", "#9ECC3B");

            // Add labels (values) on top of each bar
            svg.selectAll(".bar-label")
                .data(data)
                .enter()
                .append("text")
                .attr("x", d => x(d.year) + x.bandwidth() / 2)
                .attr("y", d => y(d.value) - 5)
                .attr("text-anchor", "middle")
                .text(d => {
                    if (rawData.dataType === "percentage") {
                        return d.value.toFixed(2) + "%";
                    } else if (rawData.dataType === "float") {
                        return d.value.toFixed(2);
                    } else if (rawData.dataType === "integer") {
                        return Math.round(d.value);
                    } else {
                        return d.value;
                    }
                })
                .attr("font-size", "10px")
                .attr("fill", "#1d1d1d");
        } else {
            // If all values are zero, show dots along the x-axis
            svg.selectAll("circle")
                .data(data)
                .enter()
                .append("circle")
                .attr("cx", d => x(d.year) + x.bandwidth() / 2)
                .attr("cy", y(0))
                .attr("r", 3)
                .attr("fill", "steelblue");
        }

    }, [rawData]);

    return <svg ref={svgRef}></svg>;
};

export default BarChart;



